import React from 'react';

import Navbar from '../components/Navbar';
import PolicyContent from '../components/PolicyContent';
import Footer from '../components/Footer';

const Policy = () => {
	return (
		<>
			<Navbar />
			<PolicyContent />
			<Footer />
		</>
	);
};

export default Policy;
